import pimg1 from '../images/project/project-1/1.jpg'
import pimg2 from '../images/project/project-1/2.jpg'
import pimg3 from '../images/project/project-1/3.jpg'
import pimg4 from '../images/project/project-1/4.jpg'
import pimg5 from '../images/project/project-2/1.jpg'
import pimg6 from '../images/project/project-2/2.jpg'
import pimg7 from '../images/project/project-2/3.jpg'
import pimg8 from '../images/project/project-2/4.jpg'
import pimg9 from '../images/project/project-3/1.jpg'
import pimg10 from '../images/project/project-3/2.jpg'
import pimg11 from '../images/project/project-3/3.jpg'
import pimg12 from '../images/project/project-3/4.jpg'
import pimg13 from '../images/project/project-5/1.jpg'
import pimg14 from '../images/project/project-5/2.jpg'
import pimg15 from '../images/project/project-5/3.jpg'
import pimg16 from '../images/project/project-4/1.jpg'
import pimg17 from '../images/project/project-4/2.jpg'
import pimg18 from '../images/project/project-4/3.jpg'
import pimg19 from '../images/project/project-4/4.jpg'
import pimg20 from '../images/project/hero-project/1.jpg'
import pimg21 from '../images/project/hero-project/2.jpg'
import pimg22 from '../images/project/hero-project/3.jpg'
import pimg23 from '../images/project/hero-project/4.jpg'
import pimg24 from '../images/project/project-7/1.jpg'
import pimg25 from '../images/project/project-7/2.jpg'
import pimg26 from '../images/project/project-7/3.jpg'
import pimg27 from '../images/project/project-7/4.jpg'
import pimg28 from '../images/project/project-7/2.jpg'
import pimg29 from '../images/project/hero-project-2/1.jpg'
import pimg30 from '../images/project/hero-project-2/2.jpg'
import pimg31 from '../images/project/hero-project-2/3.jpg'
import pimg32 from '../images/project/hero-project-2/4.jpg'
import pimg33 from '../images/project/project-8/1.jpg'
import pimg34 from '../images/project/project-8/2.jpg'
import pimg35 from '../images/project/project-8/3.jpg'
import pimg36 from '../images/project/project-8/4.jpg'
import pimg37 from '../images/project/project-9/1.jpg'
import pimg38 from '../images/project/project-9/2.jpg'
import pimg39 from '../images/project/project-9/3.jpg'
import pimg40 from '../images/project/project-9/4.jpg'
import pimg41 from '../images/project/project-9/5.jpg'
import pimg42 from '../images/project/project-10/1.jpg'
import pimg43 from '../images/project/project-10/2.jpg'
import pimg44 from '../images/project/project-10/3.jpg'
import pimg45 from '../images/project/project-10/4.jpg'
import pimg46 from '../images/project/project-10/2.jpg'
import pimg47 from '../images/project/project-11/1.jpg'
import pimg48 from '../images/project/project-11/2.jpg'
import pimg49 from '../images/project/project-11/3.jpg'
import pimg50 from '../images/project/project-11/2.jpg'
import pimg51 from '../images/project/project-13/1.jpg'
import pimg52 from '../images/project/project-13/2.jpg'
import pimg53 from '../images/project/project-13/3.jpg'
import pimg54 from '../images/project/project-14/1.jpg'
import pimg55 from '../images/project/project-14/2.jpg'
import pimg56 from '../images/project/project-14/3.jpg'
import pimg57 from '../images/project/project-14/4.jpg'



import phero1 from '../images/project/hero-project-2/img-1.jpg'
import phero2 from '../images/project/hero-project-2/img-2.jpg'
import phero3 from '../images/project/hero-project-2/img-3.jpg'
import phero4 from '../images/project/hero-project-2/img-4.jpg'


import Sing1 from '../images/project-single/1.jpg'
import Sing2 from '../images/project-single/2.jpg'
import Sing3 from '../images/project-single/3.jpg'
import Sing4 from '../images/project-single/4.jpg'
import Sing5 from '../images/project-single/5.jpg'
import Sing6 from '../images/project-single/6.jpg'
import Sing7 from '../images/project-single/7.jpg'
import Sing8 from '../images/project-single/8.jpg'
import Sing9 from '../images/project-single/9.jpg'
import Sing10 from '../images/project-single/10.jpg'
import Sing11 from '../images/project-single/11.jpg'
import Sing12 from '../images/project-single/12.jpg'
import Sing13 from '../images/project-single/13.jpg'
import Sing14 from '../images/project-single/14.jpg'
import Sing15 from '../images/project-single/15.jpg'
import Sing16 from '../images/project-single/16.jpg'
import Sing17 from '../images/project-single/17.jpg'
import Sing18 from '../images/project-single/18.jpg'
import Sing19 from '../images/project-single/19.jpg'
import Sing20 from '../images/project-single/20.jpg'
import Sing21 from '../images/project-single/21.jpg'
import Sing22 from '../images/project-single/22.jpg'
import Sing23 from '../images/project-single/23.jpg'
import Sing24 from '../images/project-single/24.jpg'
import Sing25 from '../images/project-single/25.jpg'
import Sing26 from '../images/project-single/26.jpg'
import Sing27 from '../images/project-single/27.jpg'
import Sing28 from '../images/project-single/28.jpg'
import Sing29 from '../images/project-single/29.jpg'
import Sing30 from '../images/project-single/30.jpg'
import Sing31 from '../images/project-single/31.jpg'
import Sing32 from '../images/project-single/32.jpg'
import Sing33 from '../images/project-single/33.jpg'
import Sing34 from '../images/project-single/34.jpg'
import Sing35 from '../images/project-single/35.jpg'
import Sing36 from '../images/project-single/36.jpg'
import Sing37 from '../images/project-single/37.jpg'
import Sing38 from '../images/project-single/38.jpg'
import Sing39 from '../images/project-single/39.jpg'
import Sing40 from '../images/project-single/40.jpg'
import Sing41 from '../images/project-single/41.jpg'
import Sing42 from '../images/project-single/42.jpg'
import Sing43 from '../images/project-single/43.jpg'
import Sing44 from '../images/project-single/44.jpg'
import Sing45 from '../images/project-single/45.jpg'
import Sing46 from '../images/project-single/46.jpg'
import Sing47 from '../images/project-single/47.jpg'
import Sing48 from '../images/project-single/48.jpg'
import Sing49 from '../images/project-single/49.jpg'
import Sing50 from '../images/project-single/50.jpg'
import Sing51 from '../images/project-single/51.jpg'
import Sing52 from '../images/project-single/52.jpg'
import Sing53 from '../images/project-single/53.jpg'
import Sing54 from '../images/project-single/54.jpg'
import Sing55 from '../images/project-single/55.jpg'
import Sing56 from '../images/project-single/56.jpg'
import Sing57 from '../images/project-single/57.jpg'




const Projects = [
    {
        id: '1',
        title: 'Modern House In UK',
        subtitle: 'Building, Apartment',
        slug: 'Modern-House-In-UK',
        pimg: pimg1,
        sing: Sing1,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '2',
        title: 'Art Museum In Dubai',
        subtitle: 'Building, Apartment',
        slug: 'Art-Museum-In-Dubai',
        pimg: pimg2,
        sing: Sing2,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '3',
        title: 'Alexa Complex',
        subtitle: 'Building, Apartment',
        slug: 'Alexa-Complex',
        pimg: pimg3,
        sing: Sing3,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '4',
        title: 'Bentila Palace',
        subtitle: 'Building, Apartment',
        slug: 'Bentila-Palace',
        pimg: pimg4,
        sing: Sing4,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '5',
        title: 'Modern House In UK',
        subtitle: 'Building, Apartment',
        slug: 'Modern-House2',
        pimg: pimg5,
        sing: Sing5,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '6',
        title: 'Art Museum',
        subtitle: 'Building, Apartment',
        slug: 'Art-Museum',
        pimg: pimg6,
        sing: Sing6,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '7',
        title: 'Farm House',
        subtitle: 'Building, Apartment',
        slug: 'Farm-House',
        pimg: pimg7,
        sing: Sing7,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '8',
        title: 'Dream House In UKe',
        subtitle: 'Building, Apartment',
        slug: 'Dream-House',
        pimg: pimg8,
        sing: Sing8,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '9',
        title: 'Dream House Residential',
        subtitle: 'Building, Apartment',
        slug: 'Dream-House-Residential',
        pimg: pimg9,
        sing: Sing9,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '10',
        title: 'Assembly of Rivery',
        subtitle: 'Building, Apartment',
        slug: 'Assembly-of-Rivery',
        pimg: pimg10,
        sing: Sing10,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '11',
        title: 'Seaview Residential',
        subtitle: 'Building, Apartment',
        slug: 'Seaview-Residential',
        pimg: pimg11,
        sing: Sing11,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '12',
        title: 'Museum of Paris',
        subtitle: 'Building, Apartment',
        slug: 'Museum-of-Paris',
        pimg: pimg12,
        sing: Sing12,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '13',
        title: 'Ream House Residential',
        subtitle: 'Building, Apartment',
        slug: 'Ream-House-Residential',
        pimg: pimg13,
        sing: Sing13,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '14',
        title: 'Assembly Of Rivery',
        subtitle: 'Building, Apartment',
        slug: 'Assembly-Of-Rivery',
        pimg: pimg14,
        sing: Sing14,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '15',
        title: 'Museum Of Paris',
        subtitle: 'Building, Apartment',
        slug: 'Museum-Of-Paris',
        pimg: pimg15,
        sing: Sing15,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '16',
        title: 'Office Interior Design',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design',
        pimg: pimg16,
        sing: Sing16,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '17',
        title: 'Bed Room Decor',
        subtitle: 'Building, Apartment',
        slug: 'Bed-Room-Decor',
        pimg: pimg17,
        sing: Sing17,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '18',
        title: 'Office Interior Design',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design',
        pimg: pimg18,
        sing: Sing18,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '19',
        title: 'Living Room Interior',
        subtitle: 'Building, Apartment',
        slug: 'Living-Room-Interior',
        pimg: pimg19,
        sing: Sing19,
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '20',
        title: 'Corner Interior',
        subtitle: 'Building, Apartment',
        slug: 'Corner-Interior',
        pimg: pimg20,
        sing: Sing20,
        num: '01',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '21',
        title: 'Living Room',
        subtitle: 'Building, Apartment',
        slug: 'Living-Room',
        pimg: pimg21,
        sing: Sing21,
        num: '02',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '22',
        title: 'Bed Room',
        subtitle: 'Building, Apartment',
        slug: 'Bed-Room',
        pimg: pimg22,
        sing: Sing22,
        num: '03',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '23',
        title: 'Modern Room',
        subtitle: 'Building, Apartment',
        slug: 'Modern-Room',
        pimg: pimg23,
        sing: Sing23,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '24',
        title: 'Bed Room Decor',
        subtitle: 'Building, Apartment',
        slug: 'Bed-Room-Decor2',
        pimg: pimg24,
        sing: Sing24,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '25',
        title: 'Office Interior Design',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design',
        pimg: pimg25,
        sing: Sing25,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '26',
        title: 'Living Room Interior',
        subtitle: 'Building, Apartment',
        slug: 'Living-Room-Interior',
        pimg: pimg26,
        sing: Sing26,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '27',
        title: 'Office Interior Design',
        subtitle: 'Building, Apartment',
        slug: 'Living-Room-Interior22',
        pimg: pimg27,
        sing: Sing27,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },

    {
        id: '28',
        title: 'Office Interior Design',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design28',
        pimg: pimg28,
        sing: Sing28,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '29',
        title: 'Kitchen Renovation Of a House in UK',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design29',
        pimg: pimg29,
        phero: phero1,
        sing: Sing29,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '30',
        title: 'Crystal Neora',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design30',
        pimg: pimg30,
        phero: phero2,
        sing: Sing30,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '31',
        title: 'Siyantika Glory',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design31',
        pimg: pimg31,
        phero: phero3,
        sing: Sing31,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '32',
        title: 'Kitchen Renovation Of a House in UK',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design32',
        pimg: pimg32,
        phero: phero4,
        sing: Sing32,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '33',
        title: 'Office Renovation',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design33',
        pimg: pimg33,
        phero: phero4,
        sing: Sing33,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '34',
        title: 'Kitchen Renovation',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design34',
        pimg: pimg34,
        phero: phero4,
        sing: Sing34,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '35',
        title: 'Office Renovation',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design35',
        pimg: pimg35,
        phero: phero4,
        sing: Sing35,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '36',
        title: 'Corridor Renovation',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design36',
        pimg: pimg36,
        phero: phero4,
        sing: Sing36,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
    },
    {
        id: '37',
        title: 'Sofa With Side Table',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design37',
        pimg: pimg37,
        phero: phero4,
        sing: Sing37,
        num: '01',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
        class: 'col col-lg-6 col-md-6 col-12',
    },
    {
        id: '38',
        title: 'Cozy Luxury Chair',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design38',
        pimg: pimg38,
        phero: phero4,
        sing: Sing38,
        num: '02',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
        class: 'col col-lg-6 col-md-6 col-12',
    },
    {
        id: '39',
        title: 'Kitchen Accessories',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design39',
        pimg: pimg39,
        phero: phero4,
        sing: Sing39,
        num: '03',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
        class: 'col col-lg-4 col-md-6 col-12',
    },
    {
        id: '40',
        title: 'Bathroom Organizer',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design40',
        pimg: pimg40,
        phero: phero4,
        sing: Sing40,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
        class: 'col col-lg-4 col-md-6 col-12',
    },
    {
        id: '41',
        title: 'Bedroom’s Furniture',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design41',
        pimg: pimg41,
        phero: phero4,
        sing: Sing41,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
        class: 'col col-lg-4 col-md-6 col-12',
    },
    {
        id: '42',
        title: 'Bed Room Decor',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design42',
        pimg: pimg42,
        phero: phero4,
        sing: Sing42,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '43',
        title: 'Bed Room Decor',
        subtitle: 'Office Interior Design',
        slug: 'Office-Interior-Design43',
        pimg: pimg43,
        phero: phero4,
        sing: Sing43,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '44',
        title: 'Living Room Interior',
        subtitle: 'Office Interior Design',
        slug: 'Office-Interior-Design44',
        pimg: pimg44,
        phero: phero4,
        sing: Sing44,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '45',
        title: 'Office Interior Design',
        subtitle: 'Office Interior Design',
        slug: 'Office-Interior-Design45',
        pimg: pimg45,
        phero: phero4,
        sing: Sing45,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '46',
        title: 'Office Interior Design',
        subtitle: 'Office Interior Design',
        slug: 'Office-Interior-Design46',
        pimg: pimg46,
        phero: phero4,
        sing: Sing46,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '47',
        title: 'Kitchen Renovation',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design47',
        pimg: pimg47,
        phero: phero4,
        sing: Sing47,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '48',
        title: 'Office Renovation',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design48',
        pimg: pimg48,
        phero: phero4,
        sing: Sing48,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '49',
        title: 'Corridor Renovation',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design49',
        pimg: pimg49,
        phero: phero4,
        sing: Sing49,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '50',
        title: 'Kitchen Renovation',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design50',
        pimg: pimg50,
        phero: phero4,
        sing: Sing50,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '51',
        title: 'Kitchen Renovation',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design51',
        pimg: pimg51,
        phero: phero4,
        sing: Sing51,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '52',
        title: 'Apartment Of UK',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design51',
        pimg: pimg52,
        phero: phero4,
        sing: Sing52,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '53',
        title: 'Museum Of Paris',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design53',
        pimg: pimg53,
        phero: phero4,
        sing: Sing53,
        num: '05',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '54',
        title: 'Bed Room Decor',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design54',
        pimg: pimg54,
        phero: phero4,
        sing: Sing54,
        num: '01',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '55',
        title: 'Office Interior Design',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design55',
        pimg: pimg55,
        phero: phero4,
        sing: Sing55,
        num: '02',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '56',
        title: 'Living Room Interior',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design56',
        pimg: pimg56,
        phero: phero4,
        sing: Sing56,
        num: '03',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },
    {
        id: '57',
        title: 'Office Interior Design',
        subtitle: 'Building, Apartment',
        slug: 'Office-Interior-Design57',
        pimg: pimg57,
        phero: phero4,
        sing: Sing57,
        num: '04',
        date: 'March 2025',
        location: 'Austria',
        dis: 'From futuristic skyscrapers to timeless cultural landmarks, Blaze specializes in crafting spaces that inspire and endure.',
    },





]
export default Projects;






